import { FolderCheck } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ActiveProjectsCountWidget() {
  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between pb-2'>
        <CardTitle className='text-sm font-medium text-muted-foreground'>
          Active Projects
        </CardTitle>
        <FolderCheck className='h-4 w-4 text-muted-foreground' />
      </CardHeader>
      <CardContent>
        <div className='text-3xl font-bold text-foreground'>24</div>
        <p className='text-xs text-muted-foreground mt-1'>
          Dummy data — live connection coming later
        </p>
      </CardContent>
    </Card>
  )
}
